<template>
 <div class="yxtbiz-o2o-enroll-audit">
  <template v-if="isProjectset === false">
    <div class="standard-size-16 color-gray-10">
      <div class="mb32 font-bolder">
        {{$t('pc_biz_enroll_lbl_project'/* 报名项目 */)}}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_enroll_lbl_projectname'/* 项目名称 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxtf-tooltip :open-filter="true"
                          :content="projectInfo.name"
                          placement="top">
              <div class="yxtbiz-o2o-enroll-audit_ellipsis">{{ projectInfo.name || '--' }}</div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="24" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_enroll_lbl_projecttime'/* 项目时间 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxtf-tooltip :open-filter="true" placement="top" :content="projectInfo.time">
              <div class="yxtbiz-o2o-enroll-audit_ellipsis">{{projectInfo.time || '--'}}</div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxt-row class="yxtbiz-project-audit__row" :gutter="32">
          <yxt-col :span="24">
            <yxt-button @click="goProjectDetail" type="text">{{$t('pc_biz_view_project_detail' /* 查看项目详情 */)}}</yxt-button>
          </yxt-col>
        </yxt-row>
      </div>
    </div>
  </template>
  <O2oEnrollProjectsetAudit v-else-if="isProjectset === true" :id="id" />
  <xxbiz-signup mod="info" :id="auditId" @callback="callback"></xxbiz-signup>
 </div>
</template>

<script>
import { getProjectInfo, getProjectIntegrate } from './service';
import O2oEnrollProjectsetAudit from '../../o2o-enroll-projectset-audit/src/main.vue';

export default {
  name: 'YxtbizO2oEnrollAudit',
  components: {
    O2oEnrollProjectsetAudit
  },
  props: {
    // 审核中心给的人员记录id
    auditId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      projectInfo: {}, // 项目的详情
      isProjectset: null,
      id: ''
    };
  },
  methods: {
    callback(id) {
      this.id = id;
      getProjectIntegrate(id).then(res=> {
        if (res.category === 1) {
          //  项目集任务
          this.isProjectset = true;
        } else {
          this.isProjectset = false;
          this.getProjectInfo(id);
        }
      });
    },
    // 获取项目的详情
    getProjectInfo(id) {
      const orgId = window.localStorage.getItem('orgId');
      getProjectInfo(id, orgId).then(res => {
        this.projectInfo = res;
        if (this.projectInfo.startTime && this.projectInfo.endTime) {
          this.projectInfo.time = this.projectInfo.startTime.slice(0, 16) + ' ~ ' + this.projectInfo.endTime.slice(0, 16);
        } else {
          this.projectInfo.time = '--';
        }
      });
    },
    goProjectDetail() {
      const url = `${window.location.origin}/o2o/#/preview/projectconsole/projectmgmt?id=${this.id}`;
      window.open(url);
    }
  }
};
</script>
